import { mixin as clickaway } from 'vue-clickaway';
import AddToCalendar from 'vue-add-to-calendar';

import './QdAddToCalendar.scss';
import template from './QdAddToCalendar.vhtml';

export default {
	name: 'QdAddToCalendar',
	template: template,
	components: {'AddToCalendar': AddToCalendar},
	mixins: [clickaway],
	props: {},
	data: () => ({
		showDropdown: false,
	}),
	computed: {
		contentClasses: vm => {
			const dynamicClasses = {
				'qd-share__content--border': vm.showDropdown, 
			};

			return ['qd-share__content', dynamicClasses];
		},
	},
	methods: {
		toggleDropdown() {
			this.showDropdown = !this.showDropdown;
		},
		clickAway() {
			if (this.showDropdown) {
				this.showDropdown = false;
			}
		},
	},
};
